import React, { useEffect, useCallback, useState} from 'react';
import {ALL} from 'messaging/message-types.js';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
import {setZObjectTooltip} from 'actions/index.js';
import {moveEdgeInlet} from './moveEdge.js';

const colors = new Colors();

const MessageInlets = ({doc, effect, drawingEdge, movingEdge, setZObjectTooltip}) => { 
    let [hover, setHover] = useState(undefined);
    const onMouseUp = useCallback((inletType, effect) => {
        if (drawingEdge && drawingEdge.type) {
            setHover(undefined);
            // otherwise connect them
            effect.connectInlet(inletType, drawingEdge.node, drawingEdge.type); 
        } else if (movingEdge) {
            setHover(undefined);
            moveEdgeInlet(effect, inletType, movingEdge);
        }
    }, [drawingEdge, movingEdge, setHover]);

    useEffect(() => {
        if (hover) {
            let id = effect.zObject ? effect.zObject.id : effect.id;
            let pos = effect.state.windows.windowPositions[id];
            if (!pos) {
                return;
            }
            setZObjectTooltip(
                effect.subSequence.id,
                {x: pos.x + hover.i * 20, y: pos.y - 30},
                hover.text
            );
        } else {
            setZObjectTooltip(undefined);
        }
    }, [hover, effect]);

    const onMouseOver = useCallback((inlet, i=0) => {
        if (effect.name !== "instancedSubpatch" && i !== undefined && doc && doc(effect.name) && doc(effect.name).params) {
            let _doc = doc(effect.name);
            let params = Object.keys(doc(effect.name).params);
            let values = Object.values(doc(effect.name).params);
            if (!isNaN(_doc.inlets)) {
                if (params.length < _doc.inlets) {
                    i -= (_doc.inlets - params.length);
                }
            } else if (Array.isArray(_doc.inlets)) {
                params = _doc.inlets;
            }
            let text = effect.name + ': ' + (params[i] || inlet);
            if (values[i] && values[i] !== "") {
                text += " " + values[i];
            }
            if (effect.effect && effect.effect.inletObjects && effect.effect.inletObjects[i]) {
                text = effect.effect.inletObjects[i]._text;
                if (text === "") {
                    text = Object.keys(effect.effect.inlets)[i]; //"Input " + i;
                }
            }
            setHover({text: text, i});
        } else {
            setHover({text: inlet, i});
        }
    }, [setHover]);

    if (!effect.inlets) { return ''; }
    let inlets = Object.keys(effect.inlets);

    if (inlets.includes("Input")) {
        // make sure its first
        inlets = ["Input", ... inlets.filter(i => i !== "Input")];
    }
        
    let moreInlets = [];
    let inletDocs = [];
    if (effect.effect && effect.effect.inlets) {
        let keys = Object.keys(effect.effect.inlets).filter(
            k => !inlets.includes(k));
        let obj = effect.effect;
        let _keys = [];

        let isInstance = effect.name === "instancedSubpatch";
        for (let i=0; i < keys.length; i++) {
            if (obj.inletObjects && obj.inletObjects[i] && obj.inletObjects[i]._text !== '') {
                inletDocs[i] = obj.inletObjects[i]._text;
            } else {
                inletDocs[i] = keys[i];
            }

            if (obj.inletObjects && obj.inletObjects[i] && obj.inletObjects[i].isDeleted) {
                // skip
                inletDocs.splice(-1);
            } else {
                if (obj.inletObjects &&
                    obj.inletObjects[i] &&
                    obj.implements &&
                    !obj.implements.instanceInlets.find(
                        x => x.inletNumber === obj.inletObjects[i].inletNumber)) {
                    // We SKIP shared inlets w/in instance objects
                    inletDocs.splice(-1);
                }  else if (obj.inletObjects &&
                    obj.inletObjects[i] &&
                    obj.hasInstances &&
                            obj.instanceInlets.includes(obj.inletObjects[i])) {
                    // We SKIP implemnt inlets w/in a subpatch w instances
                    inletDocs.splice(-1);
                }
                else {
                    if (obj.implements) {
                        if (obj.implements.inletObjects && obj.implements.inletObjects[i] && obj.implements.inletObjects[i]._text !== '') {
                            inletDocs[i] = (obj.implements.inletObjects[i]._text);
                        } 
                    } 
                        // otherwise add
                    _keys.push(keys[i]);
                }
            }
        }
        moreInlets = _keys;
    }

    inletDocs = inletDocs.filter(x => x);

    if (effect.isOutlet) {
        inlets = inlets.slice(0, 1);
    }

    let getStyle = (name) => drawingEdge && drawingEdge.type === name ?
        {
            backgroundColor: colors.getColorForHash(name)
        } : {};

    return (
        <div className="inlets">
          {/*hover && <div className="msg-tooltip"><div className="dot"/>{hover}</div>*/}
          {inlets.map(
              (inlet, i) => <div
                              key={inlet}
                              onMouseLeave={() => setHover(undefined)}
                              onMouseOver={() => onMouseOver(inlet, i)}
                              style={getStyle(inlet)}
                              onMouseUp={() => onMouseUp(inlet, effect)}
                              id={effect.getFullType(inlet)}
                              className={effect.isInletConnected(inlet) ? "inlet connected" : "inlet"}/>)}
          {moreInlets.map(
              (inlet, i) => <div
                              key={inlet}
                              onMouseLeave={() => setHover(undefined)}
                              style={getStyle(inlet)}
                              onMouseOver={() => onMouseOver(inletDocs[i], i + inlets.length)}
                              onMouseUp={() => onMouseUp(inlet, effect.effect)}
                              id={effect.effect.getFullType(inlet)}
                              className={
                                  effect.effect.isInletConnected(inlet) ? "inlet connected" : "inlet"}/>)}
        </div>);
}

const mapStateToProps = (state, props) => {
    let subSequence = props.subSequence || props.effect.subSequence || (props.effect.track && props.effect.track.subSequence);
    if (subSequence) {
        let numInlets = props.effect.numInlets;
        if (props.effect.effect) {
            numInlets += props.effect.effect.numInlets;
        }
        return {
            drawingEdge: state.pads.drawingEdges[subSequence.id],
            numInlets,
            movingEdge: state.pads.movingEdge
        };
    }
    return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
      setZObjectTooltip: (id, pos, text) => dispatch(setZObjectTooltip(id, pos, text))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageInlets);
